<template>
    <treeselect
        v-model="value"
        :multiple="true"
        :options="options"
        @update:modelValue="handleInput"
        :flat="true"
        :placeholder="placeholder || 'Selectionner'"
    />
</template>

<script setup>
import { ref } from "vue";
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";

const props = defineProps({
    context: Object,
    placeholder: String,
});

const initial_value =
    typeof props.context.valueCallback === "function"
        ? props.context.valueCallback(props.context.value)
        : props.context.value;

const value = ref(initial_value || []);

const initial_options =
    typeof props.context.optionsCallback === "function"
        ? await props.context.optionsCallback()
        : props.context.options;

const options = ref(initial_options || []);

function handleInput(modelData) {
    props.context.node.input(modelData);
}
</script>

<style lang="scss">
.vue-treeselect {
    margin-bottom: var(--spacing);
}

.vue-treeselect__input {
    height: auto !important;
}
.vue-treeselect__multi-value-item {
    font-size: 1rem;
}

.vue-treeselect__input {
    margin-bottom: 0 !important;
    font-size: 1rem;
}
// .vue-treeselect__multi-value {
//     display: flex;
//     align-items: center;
// }
</style>
